export default __webpack_public_path__ + "static/media/schedule pdf demo.58fc259c.png";